import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { toast } from '@workspace/ui/components/sonner';
import { useEffect } from 'react';
import { useSocket } from '~/context/socket/socket-context';
import { m } from '~/paraglide/messages.js';
import { KYCVerification } from '../-components/kyc-verification';

export const Route = createFileRoute('/_authenticated/verify-identity/kyc/')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { socket } = useSocket();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    socket.on(
      'compliance.status_updated',
      (data: { status: 'approved' | 'rejected' }) => {
        if (data.status === 'approved') {
          toast.success(m['verify_identity.toast_approved']());
          setTimeout(() => {
            navigate({ to: '/' });
          }, 2000);
        }
      },
    );

    return () => {
      socket.off('compliance.status_updated');
    };
  }, []);

  return <KYCVerification />;
}
